import React, { useEffect, useRef, useState } from "react";
import Plandetail from "./plandetail";
import { useDispatch, useSelector } from "react-redux";
import {
  setCity,
  getPackParams,
  getSingleImagingPackage,
  Imaginetestimonials,
} from "../../Redux/Actions";
import { GET_DETAILS_IMG_PACKAGES_RESET } from "../../Redux/Constants";
import { Scroll } from "../Scroll function/scroll";
import ErrorPage from "../../Pages/ErrorPage";
import { useHistory } from "react-router-dom";
// import ImagingHeader from "./ImagingHeader";
import ImagingFooter from "./ImagingFooter";
import TopNav from "../TopNav/TopNav";
import SimpleForm from "../chatbot/SimpleForm";
import { Link } from "react-router-dom";
// import Header from "../Header/Header";
import ScrolltoTop from "../Scrolltotop/ScrolltoTop";
// import Footer from "../Footer/Footer";
import stars from "../../Assets/newAsset/stars.svg";
import { Onecomponent } from "../../Pages/Career";
import { connect } from "react-redux";
import Featured from "../../Pages/homePage/Components/Featured";
import SubFooter from "../SubFooter/SubFooter";
import { FaCheck } from "react-icons/fa";
import MObileBG from "../../Assets/newAsset/imaging/sam.webp";
import "../Plan-detail/PlanDetailsPage.css";
import Content from "../../Pages/homePage/Components/Content";
import Loader from "../Loader/Loader.js";
import Apointment from "../../Pages/homePage/Components/Apointment";
import step1 from "../../Assets/newAsset/lpassets/newAssets/step1.webp";
import step2 from "../../Assets/newAsset/lpassets/newAssets/step2.webp";
import step3 from "../../Assets/newAsset/lpassets/newAssets/step3.webp";
import step4 from "../../Assets/newAsset/lpassets/newAssets/step4.webp";
import step5 from "../../Assets/newAsset/lpassets/newAssets/step5.webp";

import Meta from "../Meta";
import TestCr from "../../Pages/homePage/TestCr";

// import PlanDetailAccordion from "./PlanDetailAccordion";
import "./ImagingDetail.css";
//new plan details component
import ImagingPlanComponent from "./ImagingPlanComponent";
import Tool1 from "../../Assets/newAsset/plandetails/docTool1.svg";
import Tool2 from "../../Assets/newAsset/plandetails/tool2.svg";
import Tool3 from "../../Assets/newAsset/plandetails/tool3.svg";
//IMPORTING BOOK NOW BAR FROM JSX
import BookNow from "./BookNow";
import Prefix from "../../config/ApiPrefix";
import Axios from "../../config/Axios";
import "../../Pages/homePage/Components/Content.css";
import logo from "../../Assets/newAsset/lpassets/newAssets/mainLogo.webp";
import { json } from "express";
import ImagingNewHeader from "../Redcliffe-Imaging/ImagingNewHeader";
import TestimonialNew from "../../Pages/homePage/Components/TestimonialNew";

const stepsData = [
  {
    id: 1,
    img: step1,
    desc: "Temperature Checks",
  },
  {
    id: 2,
    img: step2,
    desc: "Secure Packaging",
  },
  {
    id: 3,
    img: step3,
    desc: "Stored Safely",
  },
  {
    id: 4,
    img: step4,
    desc: "Regular Sanitization",
  },
  {
    id: 5,
    img: step5,
    desc: "No Contact Delivery",
  },
];
//FAQ's Data//

const FAQ = [
  {
    id: 1,
    title: "Who should get tested for COVID-19 test? ",
    desc:
      "If someone is having symptoms of an infected respiratory tract, including a persistent cough, sore throat, shortness of breath and fever, that would definitely be a clear sign to go in and get your COVID-19 test done. Also, it is important to get your COVID-19 test done if you think you have come in contact with a confirmed case of a coronavirus patient. .",
  },
  {
    id: 2,
    title: "What are the common symptoms of COVID-19 infection?",
    desc:
      "The most common symptoms of coronavirus disease are dry cough, fatigue, body ache and fever. Some patients may experience more severe forms of the disease, like pneumonia. The best way to confirm if you have caught the virus producing COVID-19 disease is with a COVID-19 laboratory test.",
  },
  {
    id: 3,
    title:
      "Is it important to get my family members tested for COVID-19 if the doctor has prescribed for my RT-PCR test?",
    desc:
      "It is important and safe to get your COVID-19 test done if you have come in close contact with an infected person even if the person is your family member. In the meantime, you and your family members should take necessary precautions such as wearing a mask, proper sanitization, washing your hands for at least 20 seconds and following all safety and hygiene measures.",
  },
  {
    id: 4,
    title: "How to book covid-19 test?",
    desc:
      "Booking a COVID-19 test is easy. You need to visit our website redcliffelabs.com and fill in your details. Our customer service will contact you for home sample collection. To book your COVID-19 test, contact us at 898 898 8787.",
  },
  {
    id: 5,
    title:
      "After booking COVID-19 test at Redcliffe Labs, when will I visit the centre for the test?",
    desc:
      "We understand the importance of lives and the intricacies of this pandemic situation. We thus recommend patients to get their tests done safely at their home. We are providing our patients with the sample home collection service by our expert Phlebotomists. For home collection, you can book your appointment for COVID-19 test at http://redcliffelabs.com/ or by calling us at 898 898 8787.",
  },
  {
    id: 6,
    title: "how can i know if i had covid-19 in past?",
    desc:
      "Whether someone has had covid infection in the past, we at Redcliffe Labs provide our patients with Covid Antibody Test. These tests are usually done via blood samples. Covid Antibody tests are not done to detect covid but it is done to detect whether or not you have had covid infection in the past.",
  },
  {
    id: 7,
    title: "Is it safe to get my test done at home?",
    desc:
      "At Redcliffe Labs, we have a proficient team of Phlebotomists who are trained to follow all safety measures needed for COVID–19 home sample collection. To ensure safety, our Phlebotomists wear Disposable (single use) Personal Protective Equipment (PPE) consisting of gloves, N95 mask, goggles, face shield, hair cover and shoe cover. Once the sample is collected, they dispose of the PPE kit worn during sample collection.",
  },
  {
    id: 8,
    title: "How long does it take to get COVID-19 test results?",
    desc:
      "It usually takes 24-48 hours to get the COVID-19 test report from the time of sample collection.",
  },
  {
    id: 9,
    title: "What is the current testing method used at Redcliffe Labs?",
    desc:
      "At present, RT-PCR test is recommended to detect the presence of COVID-19 virus. COVID Antibody tests are also being done at our labs to ascertain if someone has had coronavirus in the past.",
  },
  {
    id: 10,
    title: "What if I am tested positive for COVID?",
    desc:
      "If you test positive, try to isolate yourself to prevent others from getting sick. Get in touch with your doctor for further medical assistance. If you test negative, you probably were not infected at the time of sample collection.",
  },
];
//plandetail
const dataforPlan = [
  {
    id: 1,
    img: Tool1,
    question: "Who all are eligible for the test?",
    answer: "",
  },
  {
    id: 2,
    img: Tool2,
    question: "Why take this test?",
    answer: "",
  },
  {
    id: 3,
    img: Tool3,
    question: "What are the benefits of this test?",
    answer: "",
  },
];
//importing CARASOUL
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
//RESPONSIVE SCRRREN
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const ImagingDetail = (props) => {

  const packagename = props.match.params.packagename;
  const { loading, packageDetails, error } = props;
  const navCity = useSelector((state) => state.navCityList);
  const { navCities, loading: loadingNavCities } = navCity;
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;
  const [cityonUrl, setCityOnUrl] = useState(JoinedCityName);
  const [Error, setError] = useState(false);
  const [bookNow, setBooknow] = useState(false);
  const [scrool, setScroll] = useState(0);
  const [DivSize, setDivSize] = useState(true);
  const dispatch = useDispatch();
  const history = useHistory();
  const currentCity = useRef();
  const [testParam, setTestParam] = useState([]);

  const imagineTestimonial = useSelector(
    (state) => state.ImaginetestimonialsReducer
  );
  const { loading: testLoading } = imagineTestimonial;

  useEffect(() => {
    dispatch(Imaginetestimonials());
  }, []);

  useEffect(() => {
    setDivSize(true);
  }, [citySelect]);

  const Captalize = (word) => {
    return `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`
  }

  useEffect(() => {

    Scroll()
    const lastStringOnUrl = props.match.params.packagename.split("-").pop();
    const SplitedCityName = lastStringOnUrl.split("_")
    var expectedCityOnUrl = ""

    if (SplitedCityName.length > 1) {
      expectedCityOnUrl = Captalize(SplitedCityName[0]) + `_${Captalize(SplitedCityName[1])}`
    } else {
      expectedCityOnUrl = Captalize(lastStringOnUrl)
    }

    dispatch({
      type: GET_DETAILS_IMG_PACKAGES_RESET,
    });

    Axios.get(`${Prefix.api}/core/alldisplaycities/`).then(({ data }) => {
      if (data.cities.includes(expectedCityOnUrl)) {
          dispatch(setCity(expectedCityOnUrl))
          const CenterAddress = JSON.parse(localStorage.getItem("hospAddr"));
          if(CenterAddress){
            dispatch(getSingleImagingPackage(props.match.params.packagename.replace(`-${lastStringOnUrl}`, ''),expectedCityOnUrl,CenterAddress?.id))
          }else{
            dispatch(getSingleImagingPackage(props.match.params.packagename.replace(`-${lastStringOnUrl}`, ''),expectedCityOnUrl,false))
          }
      } else {
        //  console.log("city not selected ==")
        const CenterAddress = JSON.parse(localStorage.getItem("hospAddr"));
        if(CenterAddress){
          dispatch(getSingleImagingPackage(props.match.params.packagename,false,CenterAddress?.id))
        }else{
          dispatch(getSingleImagingPackage(props.match.params.packagename,false,false))
        }
      }
    })

  },[packagename])

  let packUrl = packagename.split("-");
  let packSlug = packUrl.join("-");

  packSlug = packSlug.substring(0, packSlug.lastIndexOf("-"));

  const NewArray = packUrl.pop().split("_");

  let firstName =
    NewArray[0].substring(0, 1).toUpperCase() + NewArray[0].substring(1);
  var JoinedCityName = firstName;
  if (NewArray.length > 1) {
    let secondName =
      NewArray[1].substring(0, 1).toUpperCase() + NewArray[1].substring(1);
    JoinedCityName = firstName + "_" + secondName;
  }

  useEffect(() => {
    const screenSize = window.screen.width;
    // console.log(screenSize);
    if (screenSize < 780) {
      setBooknow(true);
    } else {
      setBooknow(false);
    }
    
  }, []);

  const handelScroll = () => {
    window.addEventListener("scroll", function() {
      setScroll(window.scrollY);
    });
  };

  useEffect(() => {
    handelScroll();
    setCityOnUrl(citySelect);
  }, []);

  useEffect(() => {
    setTestParam(props?.testPara);
  }, [props?.testPara]);

  if (packageDetails) {
    try {
      if (
        packageDetails.package_city_metainfo &&
        packageDetails.package_city_metainfo?.og_tag !== ""
      ) {
        var Og = JSON.parse(packageDetails.package_city_metainfo.og_tag);
      } else {
        var Og = JSON.parse(packageDetails.og_tag);
      }
    } catch (error) {}

    try {
      if (
        packageDetails.package_city_metainfo &&
        packageDetails.package_city_metainfo?.twitter_card !== ""
      ) {
        var twCard = JSON.parse(
          packageDetails.package_city_metainfo.twitter_card
        );
      } else {
        var twCard = JSON.parse(packageDetails.twitter_card);
        // console.log(twCard, "package not city type");
      }
    } catch (error) {}

    try {
      if (
        packageDetails.package_city_metainfo &&
        packageDetails.package_city_metainfo?.meta_description !== ""
      ) {
        var metaDescrip = packageDetails.package_city_metainfo.meta_description;
        //console.log(metaDescrip, "from meta object data");
      } else {
        var metaDescrip = packageDetails.meta_description;
        //  console.log(metaDescrip, "from default object");
      }
    } catch (error) {
      //console.log(error, "error from metas");
    }

    try {
      if (packageDetails?.package_city_metainfo) {
        var faqData = JSON.parse(packageDetails.package_city_metainfo?.faq);
      } else if (packageDetails?.faq) {
        var faqData = JSON.parse(packageDetails?.faq);
      } else {
        var faqData = [];
      }
    } catch (error) {
      console.log(error, "FAQ ERROR");
    }

    try {
      if (
        packageDetails?.package_city_metainfo &&
        packageDetails?.package_city_metainfo?.content !== ""
      ) {
        var desc = packageDetails?.package_city_metainfo?.content;
        // console.log(desc, "from meta object data desc");
      } else if (packageDetails.content !== "") {
        var desc = packageDetails?.content.replaceAll(
          "in Delhi",
          `in ${cityonUrl}`
        );
      } else {
        var desc = null;
      }
    } catch (error) {}

    try {
      if (
        packageDetails.package_city_metainfo &&
        packageDetails.package_city_metainfo?.scratch_code !== ""
      ) {
        var scratch_codeData =
          packageDetails.package_city_metainfo.scratch_code;
      } else {
        var scratch_codeData = false;
      }
    } catch (error) {}

    try {
      if (
        packageDetails.package_city_prices &&
        packageDetails.package_city_prices !== ""
      ) {
        var packagePrice = packageDetails.package_city_prices.package_price;
      } else {
        packagePrice = packageDetails.package_price;
      }
    } catch (error) {}

    try {
      if (
        packageDetails.package_city_prices &&
        packageDetails.package_city_prices !== ""
      ) {
        var offerPrice = packageDetails.package_city_prices.offer_price;
      } else {
        offerPrice = packageDetails.offer_price;
      }
    } catch (error) {}

    try {
      if (
        packageDetails.package_city_prices &&
        packageDetails.package_city_prices !== ""
      ) {
        var taT = packageDetails?.package_city_prices?.tat_time;
      } else {
        taT = packageDetails?.tat_time;
      }
    } catch (error) {
      //  console.log(error, "error from scratch_code");
    }

    try {
      if (packageDetails?.qna && packageDetails?.qna !== "") {
        var qnaArray = JSON.parse(
          packageDetails?.qna.replaceAll("in Delhi", `in ${props.citySel}`)
        );
        // console.log(qnaArray, "Qna array");
        //   console.log(taT, "from meta object data package price");
      } else {
        qnaArray = "";
      }
    } catch (error) {
      //// console.log(error, "Qna array error");
    }

    try {
      if (
        packageDetails?.text_criteria &&
        packageDetails?.text_criteria !== ""
      ) {
        var crieteria = JSON.parse(
          packageDetails?.text_criteria.replaceAll("in Delhi", `in ${cityonUrl}`)
        );
      } else {
        crieteria = "";
      }
    } catch (error) {}
    var recommndedPackage = packageDetails.related_packages;
  }

  // const json = '{"result":{"key" : "one"}, "count":42}';
  // const obj = JSON.parse(json);
  // console.log("packdetail data" , obj);

  // //IF CONDITION FOR META description
  // if (packageDetails && packageDetails?.packDetail) {
  //     var content = packDetail.package_city_metainfo?.content;
  //     console.log("content ", JSON.parse(content));
  // }
  //for OURPAKAGE CARASOEL

  //for FAQ DATA

  //for SCRATCH DATA
  if (packageDetails && packageDetails?.packDetail) {
    var recommndedPackage = packageDetails.packDetail.related_packages;
  }


  return (
    <React.Fragment>
      {packageDetails?.meta_title && packageDetails?.og_tag && Og && twCard && (
        <Meta
          title={
            packageDetails.package_city_metainfo
              ? packageDetails.package_city_metainfo.meta_title
              : packageDetails.meta_title?.replace("Delhi", `${cityonUrl}`)
          }
          description={
            packageDetails.package_city_metainfo
              ? packageDetails.package_city_metainfo.meta_description
              : packageDetails.meta_description?.replace(
                  "Delhi",
                  `${cityonUrl}`
                )
          }
          keywords={
            packageDetails.package_city_metainfo
              ? packageDetails.package_city_metainfo.meta_keyword
              : packageDetails.meta_keyword
          }
        >
          <meta property="robots" content={Og.robots ? Og.robots : ""} />
          <meta
            property="og:title"
            content={Og?.title?.replace("Delhi", `${cityonUrl}`)}
          />
          <meta property="og:site_name" content={Og.site} />
          <meta
            property="og:url"
            content={Og?.url?.replace("delhi", `${cityonUrl?.toLowerCase()}`)}
          />
          <meta property="og:description" content={Og?.description} />
          <meta property="og:type" content={Og?.type} />
          <meta property="og:image" content={Og?.image} />
          {scratch_codeData ? (
            <script type="application/ld+json">{scratch_codeData}</script>
          ) : null}
          <script type="application/ld+json">{JSON.stringify(faqData)}</script>
          <meta name="twitter:card" content={twCard ? twCard.card : ""} />
          <meta name="twitter:site" content={twCard ? twCard.site : ""} />
          <meta
            name="twitter:title"
            content={
              twCard ? twCard.title?.replace("Delhi", `${cityonUrl}`) : ""
            }
          />
          <meta
            name="twitter:description"
            content={
              twCard ? twCard.description?.replace("Delhi", `${cityonUrl}`) : ""
            }
          />
          <meta name="twitter:image" content={twCard ? twCard.image : ""} />
        </Meta>
      )}
      <div>
        {/***Book Now bar below */}
        {/* {scrool === 0 ? (
          <>
            <TopNav />
            <Header />
          </>
        ) : bookNow && packDetail ? (
          <BookNow packDetail={packDetail} />
        ) : (
          <>
            <TopNav />
            <Header />
          </>
        )} */}

        {/* <TopNav isImagine={true} /> */}
        <ImagingNewHeader />
        {loading ? (
          <Loader />
        ) : error || Error ? (
          <React.Fragment>
            <>
              <ErrorPage />
              <ScrolltoTop />
              <ImagingFooter />
            </>
          </React.Fragment>
        ) : (
          <div className="plandetailsNewBanner">
            <ImagingPlanComponent
              citySel={props.citySel}
              packageDetails={packageDetails}
              // QNA={crieteria && crieteria}
              btmQna={qnaArray && qnaArray}
              testPara={testParam && testParam}
              // addr = {props.location.state.listDesc}
            />

            {recommndedPackage && recommndedPackage.length > 0 ? (
              <div className="parentDiv ">
                <div className="childDiv container">
                  <div className="HeaderDiv">
                    <div className="divHeading">
                      <h2>
                        Best health check-up packages in{" "}
                        {JoinedCityName.replace("_", " ")}
                      </h2>
                    </div>

                    <a href={`${process.env.RAZZLE_APP_BASE_URL}/health-checkup-packages`}>View All</a>
                  </div>

                  <Carousel
                    swipeable={true}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={2500}
                    transitionDuration={200}
                    deviceType={"tablet"}
                  >
                    {loading ? (
                      <Loader />
                    ) : (
                      recommndedPackage.map((card) => (
                        <div
                          className={
                            card.is_premium
                              ? "Package__card bgPremium "
                              : "Package__card bgOrdinary "
                          }
                          key={card.id}
                        >
                          <div className="packageTop">
                            <span
                              className={
                                card.is_premium ? "bgGreen" : "bgOrange"
                              }
                            >
                              {card.is_premium
                                ? "Most Popular Plan"
                                : "Heath Check-up"}
                            </span>{" "}
                          </div>

                          <div className="packageBottom">
                            <div className="Package__cardTitle">
                              <span
                                className={
                                  card.is_premium ? "textWhite" : "textBlue "
                                }
                              >
                                <Link
                                  className={
                                    card.is_premium ? "textWhite" : "textBlue "
                                  }
                                  to={`/${
                                    card.slug
                                  }-${citySelected.citySelect
                                    ?.toLowerCase()
                                    .replace(" ", "-")}`}
                                >
                                  {card.name}
                                </Link>
                              </span>
                            </div>
                            <div className="Package__cardList">
                              <ul>
                                <li>
                                  {" "}
                                  <FaCheck /> Total no.of Tests -{" "}
                                  {card.parameter}{" "}
                                </li>
                                <li>
                                  {" "}
                                  <FaCheck /> Quick Turn Around Time{" "}
                                </li>
                                <li>
                                  {" "}
                                  <FaCheck /> Reporting as per NABL ISO
                                  guidelines{" "}
                                </li>
                              </ul>
                            </div>
                            <div className="Package__cardPrice">
                              <span
                                className={
                                  card.is_premium ? "text_Color" : "card__Mrp"
                                }
                              >
                                {" "}
                                MRP : &#8377; {card.package_price}
                              </span>
                              <span
                                className={
                                  card.is_premium
                                    ? " card__offerPrice  "
                                    : "   card__offerPrice textGrey"
                                }
                              >
                                {" "}
                                Offer Price : &#8377; {card.offer_price}
                              </span>
                            </div>

                            <Link
                              className="Package__BookButton"
                              to={`/${card.slug}${
                                citySelected.citySelect != ""
                                  ? `-${citySelected.citySelect
                                      .toLowerCase()
                                      .replace(" ", "-")}`
                                  : ""
                              }`}
                            >
                              <span>Book Now</span>
                            </Link>
                          </div>
                        </div>
                      ))
                    )}
                  </Carousel>
                </div>
              </div>
            ) : (
              ""
            )}

            {/**Ourpackages */}

            {/*** wHY CHOOSE US */}

            {/**SAFETY STEPS */}
            {/* <div className="safetyDiv"  >
              <h2>5 Steps to Safety</h2>
              <p>
                {" "}
                <span>10+ Lacs</span> Total orders delivered
              </p>
              <div className="safetySteps">
                {stepsData.map((values, index) => (
                  <div className="safety__card" key={values.id}>
                    <div className="safety_cardIMG">
                      <img src={values.img} alt="image"></img>
                    </div>
                    <div className="steps">
                      <span>{values.id}</span>
                    </div>
                    <div className="safetyStep">
                      <span>{values.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            {/***APPOINTMENT DIV */}
            {/* <div className="appointMentLpDiv">
              <Apointment img={stars} />

              <div className="mobileApointment">
                <h5>Make Appointment</h5>
                <p>Start Your Journey With Healthy India Ki Trusted Lab.</p>
              </div>
              <LpForm
                butname={"Book Your Test"}
                position={"bottom"}
                title={"Book Your Test"}
              />
            </div> */}
            {/* *ONE COMPONENT */}

            {desc == "empty" ? null : (
              <div
                className={DivSize ? "expanTrue readMoreDiv" : "readMoreDiv"}
              >
                {desc && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${desc}`,
                    }}
                  >
                    
                  </div>
                  
                )}
              </div>
            )}

            {/* <Onecomponent title={metaPacTitle} content={metaDescrip} />/*}
            <TestCr /> 

            {/*** TE S T I M O N I A L */}
            {faqData == "" ? null : loading ? (
              <Loader />
            ) : (
              <TestCr faq={faqData} />
            )}

            {loading ? (
              "loading.."
            ) : imagineTestimonial &&
              imagineTestimonial.testimonials &&
              imagineTestimonial.testimonials.results &&
              imagineTestimonial.testimonials.results.length > 0 ? (
              <div className="imagingTest">
               <TestimonialNew />
              </div>
            ) : null}
          </div>
        )}
        <Featured />
        {/* <ScrolltoTop /> */}
        <ImagingFooter telNumber="898 898 0101" />
        <div className="chatbot">
          <SimpleForm />
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  testPara: state.getPackParamsReducer?.testParam,
  citySel: state.cityOnTopNav?.citySelect,
  packageDetails: state.getImgDetalReducer.ImgPackDetals,
  loading: state.getImgDetalReducer?.loading,
  error: state.getImgDetalReducer?.error,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getPackParams: (packagesId) => {
      dispatch(getPackParams(packagesId));
    },
    getImgPackDetails: (packSlug, JoinedCityName, CenterAddress) => {
      dispatch(
        getSingleImagingPackage(packSlug, JoinedCityName, CenterAddress)
      );
    },
  };
};

export default {
  component: connect(
    mapStateToProps,
    mapDispatchToProps
  )(React.memo(ImagingDetail)),
};
